import * as React from "react";
import { connect } from "react-redux";
import SignUp from "../../screens/SignUp";
// import { signup } from "./actions";
import { signup,fetchtandc } from "./action";
export interface Props {
  signup: any;
}
class SignUpContainer extends React.Component<Props, State> {
  render() {
    return <SignUp 
      signup={this.props.signup} 
      fetchtandc={this.props.fetchtandc}
      tnc={this.props.tnc}
    />;
  }
}
function bindAction(dispatch) {
  // console.log("--------------------------");
  return {
    signup: (value) => {
      dispatch(signup(value));
    },
    fetchtandc:()=>{
      dispatch(fetchtandc());
    }
  };
}
const mapStateToProps = (state) => {
  return {
    tnc:state.SignupReducer.tnc,
  }
};

export default connect(mapStateToProps, bindAction)(SignUpContainer);
